import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {Vector2Like} from '../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {ref, Ref} from 'vue';
import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';

export type OpenTabMenuForChangeTypeCallback = (node: BaseNodeType) => void;
export class EditorContextMenuStoreControllerClass {
	private static _instance: EditorContextMenuStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorContextMenuStoreControllerClass());
	}

	private constructor() {}

	private _position: Ref<Vector2Like> = ref({
		x: 0,
		y: 0,
	});
	private _nodeId: Ref<CoreGraphNodeId | null> = ref(null);
	private _paramId: Ref<CoreGraphNodeId | null> = ref(null);
	private _uploadName: Ref<string | null> = ref(null);
	private _openTabMenuForChangeType: OpenTabMenuForChangeTypeCallback | undefined;

	// getters

	position(): Vector2Like {
		return this._position.value;
	}
	nodeId(): CoreGraphNodeId | null {
		return this._nodeId.value;
	}
	paramId(): CoreGraphNodeId | null {
		return this._paramId.value;
	}
	uploadName(): string | null {
		return this._uploadName.value;
	}
	openTabMenuForChangeType() {
		return this._openTabMenuForChangeType;
	}

	// mutations
	setPosition(position: Vector2Like): void {
		this._position.value.x = position.x;
		this._position.value.y = position.y;
	}
	setNodeId(nodeId: CoreGraphNodeId | null, openTabMenuForChangeType?: OpenTabMenuForChangeTypeCallback): void {
		this._openTabMenuForChangeType = openTabMenuForChangeType;
		this._nodeId.value = nodeId;
	}
	setParamId(paramId: CoreGraphNodeId | null): void {
		this._paramId.value = paramId;
	}
	setUploadName(uploadName: string | null): void {
		this._uploadName.value = uploadName;
	}
}

export const EditorContextMenuStoreController = EditorContextMenuStoreControllerClass.instance();
